import { render, staticRenderFns } from "./GroupsTab.vue?vue&type=template&id=ccab4f64"
import script from "./GroupsTab.vue?vue&type=script&lang=js"
export * from "./GroupsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports